import Vue from 'vue'
import Vuex from 'vuex'

import defaultOrg from '@/config/defaultOrg.json'

Vue.use(Vuex)

const initialState = {
  appDescription: {},
  assetRoot: defaultOrg.assetRoot,
  gtmId: '',
  posthogKey: '',
  orgLogo: defaultOrg.orgInfo.orgLogo,
  orgName: defaultOrg.orgInfo.orgName,
  orgInfo: {},
  orgSusi: null,
  loading: true
}

export default {
  namespaced: true,

  state: () => initialState,

  getters: {},

  mutations: {
    /* common mutations */

    syncState(state, newState) {
      // spread operator breaks reactivity: state = {...state, ...newState}
      Object.keys(newState).forEach((key) => {
        // ignore any deprecated keys
        if (key in state) state[key] = newState[key]
      })
    },

    setLoading(state, loading) {
      state.loading = loading
    },

    /* specific mutations */

    setAppConfig(state, { appDescription, assetRoot, gtmId, posthogKey }) {
      state.appDescription = appDescription
      state.assetRoot = assetRoot
      state.gtmId = gtmId
      state.posthogKey = posthogKey
    },

    setOrgInfo(state, orgInfo) {
      state.orgInfo = orgInfo
      /*
      // identity
      const { orgName, orgLogo } = orgInfo
      state.orgName = orgName
      state.orgLogo = orgLogo

      // policies
      const { about, contact, disclaimer, privacy, tou } = orgInfo
      state.about = about
      state.contact = contact
      state.disclaimer = disclaimer
      state.privacy = privacy
      state.tou = tou

      // web
      const { email, website, social } = orgInfo
      state.email = email
      state.website = website
      state.social = social
      */
    },

    setOrgSusi(state, orgSusi) {
      state.orgSusi = orgSusi
    }
  },

  actions: {
    /* common actions */

    restoreState({ state, commit }, { sessionState }) {
      commit('syncState', { ...state, ...sessionState })
    },

    /* specific actions */

    updateOrg({ commit }, { appDescription, assetRoot, gtmId, posthogKey, orgInfo, orgSusi }) {
      commit('setAppConfig', { appDescription, assetRoot, gtmId, posthogKey })
      commit('setOrgInfo', orgInfo)
      commit('setOrgSusi', orgSusi)
      commit('setLoading', false)
    }
  }
}
